import { render, staticRenderFns } from "./NewAdvertisiing.vue?vue&type=template&id=91f9aa02&scoped=true"
import script from "./NewAdvertisiing.vue?vue&type=script&lang=js"
export * from "./NewAdvertisiing.vue?vue&type=script&lang=js"
import style0 from "./NewAdvertisiing.vue?vue&type=style&index=0&id=91f9aa02&prod&scoped=true&lang=less"
import style1 from "./NewAdvertisiing.vue?vue&type=style&index=1&id=91f9aa02&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91f9aa02",
  null
  
)

export default component.exports